/** Приветствие по времени суток (локальное время пользователя) */
export function getTimeGreeting(date = new Date()): string {
    const hour = date.getHours();

    if (hour >= 6 && hour < 18) {
        return 'Добрый день';
    }
    if (hour >= 18 && hour < 23) {
        return 'Добрый вечер';
    }
    return 'Доброй ночи';
}

export function formatUserGreeting(name?: string | null, date = new Date()): string {
    const greeting = getTimeGreeting(date);
    const trimmed = name?.trim();

    if (!trimmed) {
        return greeting;
    }

    const displayName = trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
    return `${greeting}, ${displayName}`;
}

/** Приветствие после регистрации / первого входа в приложение. */
export function formatWelcomeGreeting(name?: string | null): string {
    const trimmed = name?.trim();
    if (!trimmed) {
        return 'Добро пожаловать';
    }
    const displayName = trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
    return `Добро пожаловать, ${displayName}`;
}

/** Минимальное время показа приветствия (лендинг → app, bootstrap) */
export const GREETING_MIN_MS = 2500;

export const FROM_LOGIN_SESSION_KEY = 'visor-from-login';

export type BootstrapMode = 'welcome' | 'silent';

/** Вызывается после успешного входа с лендинга — следующий bootstrap покажет приветствие. */
export function markWelcomeBootstrap() {
    sessionStorage.setItem(FROM_LOGIN_SESSION_KEY, '1');
}

export function peekBootstrapMode(): BootstrapMode {
    if (!localStorage.getItem('visor-access-token')) {
        return 'silent';
    }
    return sessionStorage.getItem(FROM_LOGIN_SESSION_KEY) ? 'welcome' : 'silent';
}

/** Читает и сбрасывает флаг входа; вызывается один раз в начале init(). */
export function consumeBootstrapMode(): BootstrapMode {
    if (sessionStorage.getItem(FROM_LOGIN_SESSION_KEY)) {
        sessionStorage.removeItem(FROM_LOGIN_SESSION_KEY);
        return 'welcome';
    }
    return 'silent';
}
export const LANDING_URL =
    process.env.REACT_APP_LANDING_URL?.replace(/\/$/, '') || 'https://www.visor.business';

export const LANDING_LOGIN_URL = `${LANDING_URL}/login/`;

export function redirectToLanding() {
    window.location.href = `${LANDING_URL}/`;
}

export function redirectToLandingLogin() {
    window.location.href = LANDING_LOGIN_URL;
}
